import { Navigate, useLocation } from 'react-router-dom'

/** Redirect (replacing history) that keeps the current query string and hash, e.g. URL-driven filters. */
const NavigateWithSearch: React.FC<{ to: string }> = ({ to }) => {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: to, search, hash }} replace />
}

export default NavigateWithSearch
